import { useSelector } from "app/hooks";

export const useCustomiseReportScreen = () => {
  const { product } = useSelector((state) => state.investmentDetails);
  const redirectHome = !product;

  return {
    redirectHome,
  };
};
